import { useState, useEffect } from "react";
// import { differenceInSeconds } from "date-fns";

const CountdownTimer = ({
  matchStatus,
  firstPeriod = null,
  secondPeriod = null,
  thirdPeriod = null,
  fourthPeriod = null,
}) => {
  const [elapsedTime, setElapsedTime] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const period = fourthPeriod?.start || thirdPeriod?.start || secondPeriod?.start || firstPeriod?.start;
      const elapsedTimeInMs =
        new Date().getTime() - new Date(period).getTime();
      const elapsedTimeInSeconds = Math.floor(elapsedTimeInMs / 1000);

      setElapsedTime(elapsedTimeInSeconds);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [firstPeriod?.start, secondPeriod?.start, thirdPeriod?.start, fourthPeriod?.start]);

  // const twoDigist = (value) => (String(value).length < 2 ? `0${value}` : value);

  const getMinutes = (seconds) => {
    switch (matchStatus) {
      case "A2":
        // return Math.floor(
        //   (seconds -
        //     differenceInSeconds(secondPeriod.start, firstPeriod.end) -
        //     differenceInSeconds(thirdPeriod.start, secondPeriod.end) -
        //     differenceInSeconds(fourthPeriod.start, thirdPeriod.end)) /
        //     60
        // );

      // case "FA1":
      //   return firstPeriod && secondPeriod && thirdPeriod
      //     ? `${twoDigist(
      //         (firstPeriod?.lengthMin ?? 45) +
      //           (secondPeriod?.lengthMin ?? 45) +
      //           (thirdPeriod?.lengthMin ?? 45)
      //       )}:${twoDigist(
      //         (firstPeriod?.lengthSec ?? 0) +
      //           (secondPeriod?.lengthSec ?? 0) +
      //           (thirdPeriod?.lengthSec ?? 0)
      //       )}`
      //     : 105;

      case "A1":
        // return Math.floor(
        //   (seconds -
        //     differenceInSeconds(secondPeriod.start, firstPeriod.end) -
        //     differenceInSeconds(thirdPeriod.start, secondPeriod.end)) /
        //     60
        // );

      // case "FTR":
      //   return firstPeriod && secondPeriod
      //     ? `${twoDigist(
      //         (firstPeriod?.lengthMin ?? 45) + (secondPeriod?.lengthMin ?? 45)
      //       )}:${twoDigist(
      //         (firstPeriod?.lengthSec ?? 0) + (secondPeriod?.lengthSec ?? 0)
      //       )}`
      //     : 90;

      case "2T":
        // return Math.floor(
        //   (seconds - differenceInSeconds(secondPeriod.start, firstPeriod.end)) /
        //     60
        // );

      // case "ET":
      //   return firstPeriod
      //     ? `${twoDigist(firstPeriod?.lengthMin ?? 45)}:${twoDigist(
      //         firstPeriod?.lengthSec ?? 0
      //       )}`
      //     : 45;

      case "1T":
      default:
        return Math.floor(seconds / 60);
    }
  };

  const getFormattedTime = (totalSeconds) => {
    const seconds = totalSeconds % 60;
    const minutes = getMinutes(totalSeconds);
    const validateSeconds = matchStatus === "FIN" ? 0 : seconds;

    // if (matchStatus === "ET" || matchStatus === "FTR" || matchStatus === "FA1") return minutes;

    if (matchStatus === "FIN") return "FIN";

    return `${minutes?.toString().padStart(2, "0")}:${validateSeconds
      ?.toString()
      .padStart(2, "0")}`;
  };

  const formattedTime = getFormattedTime(elapsedTime);

  return <div>{formattedTime}</div>;
};

export default CountdownTimer;
